import React, { useEffect } from 'react';
import { ChakraProvider, Box, extendTheme } from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Statistics from './components/Statistics';
import Pricing from './components/Pricing';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import Imprint from './components/Imprint';

// Theme definieren
const theme = extendTheme({
  colors: {
    primary: '#4f46e5',
    secondary: '#ec4899',
    background: '#ffffff',
    backgroundDark: '#1a202c',
    text: '#2d3748',
    textLight: '#e2e8f0',
    highlight: '#f59e0b',
  },
  fonts: {
    heading: '"Poppins", sans-serif',
    body: '"Inter", sans-serif',
  },
});

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function MainContent() {
  return (
    <>
      <Hero />
      <Features />
      <Statistics />
      <Pricing />
    </>
  );
}

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <ScrollToTop />
        <Box display="flex" flexDirection="column" minHeight="100vh">
          <Header />
          <Box as="main" flex="1" pt="80px">
            <Routes>
              <Route path="/" element={<MainContent />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/imprint" element={<Imprint />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Router>
    </ChakraProvider>
  );
}

export default App;
